import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";

/**
 * Custom hook to manage all Redux selectors needed for final documents
 * Separates selector logic from business logic for better testability
 */
export const useFinalDocumentsData = () => {
  const { openedModalId } = useSelector((state: RootState) => state.modal);

  const {
    singleMedicalPaOrder,
    unsubscribe,
    isLoading: isLoadingSingleMedicalPaOrder,
  } = useSelector((state: RootState) => state.singleMedicalPaOrder);

  const { data: singleMedicalPaFormConfig } = useSelector(
    (state: RootState) => state.singleMedicalPaFormConfig,
  );

  const { user } = useSelector(
    (state: RootState) => state.firebaseAuthentication,
  );

  const { downloadURL, progress } = useSelector(
    (state: RootState) => state.fileUpload,
  );

  return {
    openedModalId,
    singleMedicalPaOrder,
    unsubscribe,
    isLoadingSingleMedicalPaOrder,
    singleMedicalPaFormConfig,
    user,
    downloadURL,
    progress,
  };
};
